import { render, staticRenderFns } from "./PageNotFound.vue?vue&type=template&id=b669bb36&scoped=true"
import script from "./PageNotFound.vue?vue&type=script&lang=ts"
export * from "./PageNotFound.vue?vue&type=script&lang=ts"
import style0 from "./PageNotFound.vue?vue&type=style&index=0&id=b669bb36&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b669bb36",
  null
  
)

export default component.exports